// Shared desktop-vs-mobile flag — DEVICE-AWARE.
//
// prorentz.com ships the desktop build (REACT_APP_TARGET=desktop), but a phone
// visiting prorentz.com should get the mobile app, and a computer should get the
// desktop site. So the desktop build renders the desktop UI ONLY on non-phone
// devices; on a phone (mobile user-agent OR a narrow viewport) it falls back to
// the mobile app — the exact same UX as the Render / APK build.
//
// The mobile/Render build (no REACT_APP_TARGET) is always mobile.
//
// Overrides (for testing or a "view desktop / mobile site" link):
//   ?desktop=1  → force desktop
//   ?mobile=1   → force mobile
//
// Evaluated once at page load, so it doesn't live-switch on window resize
// (a reload re-detects) — which is the right behaviour for real devices.

function _param(name) {
  return typeof window !== "undefined" && window.location.search.indexOf(name) !== -1;
}

function _isPhone() {
  if (typeof window === "undefined") return false;
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  const uaMobile = /Mobi|Android|iPhone|iPod|Windows Phone|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const narrow = typeof window.innerWidth === "number" && window.innerWidth > 0 && window.innerWidth < 768;
  return uaMobile || narrow;
}

export const IS_DESKTOP = (() => {
  if (_param("desktop=1")) return true;   // force desktop
  if (_param("mobile=1")) return false;   // force mobile
  const isDesktopBuild = process.env.REACT_APP_TARGET === "desktop";
  return isDesktopBuild && !_isPhone();   // desktop build → desktop UI only on non-phones
})();
